import { HeatingCircuit } from 'z3k-config';
import { FixedBlockType } from '../types/block-type';
import { addNewBlock } from '../utils/add-new-block';
import { HeatingMode } from 'z3k-parser/model/z3k-config/20-heating-mode';
function getAllHeatingMode(config) {
    const heating_modes = HeatingMode.get.all(config);
    //Для каждого режима набираем зоны, в которых он может работать
    const heating_zones_per_mode = Object.fromEntries(heating_modes.map((heat_mode) => [
        heat_mode.id,
        [
            {
                heating_circuit_name: 'всех контуров',
                heating_circuit_id: 1,
            },
            ...heat_mode.heating_zones
                .map((heat_zone) => {
                const heating_circuit = HeatingCircuit.get.byId(config, heat_zone.heating_circuit);
                if (heating_circuit != null) {
                    return {
                        heating_circuit_name: heating_circuit.name,
                        heating_circuit_id: heating_circuit.id,
                    };
                }
                return null;
            })
                .filter((item) => item != null),
        ],
    ]));
    return [
        heating_modes.map((heat_mode) => ({
            heat_mode_name: heat_mode.name,
            heat_mode_id: heat_mode.id,
        })),
        heating_zones_per_mode,
    ];
}
function addHeatModeBlocks(id, name, zones, color_of_logic_blocks) {
    const heat_mode_block = {
        message0: 'Активировать режим отопления %1 %2 для %3',
        args0: [
            {
                type: 'input_dummy',
            },
            {
                type: 'field_label_serializable',
                name: 'name',
                text: name,
            },
            {
                type: 'field_dropdown',
                name: 'zones',
                options: zones.map(({ heating_circuit_name, heating_circuit_id }) => [
                    heating_circuit_name,
                    heating_circuit_id.toString(),
                ]),
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(`${FixedBlockType.do_heat_mode_for_heat_circuit}:${id}`, heat_mode_block);
}
export function generateHeatModeBlocks(color_of_logic_blocks, config) {
    const [modes, heating_zones_per_mode] = getAllHeatingMode(config);
    return modes.map(({ heat_mode_id, heat_mode_name }) => {
        addHeatModeBlocks(heat_mode_id, heat_mode_name, heating_zones_per_mode[heat_mode_id], color_of_logic_blocks);
        return `${FixedBlockType.do_heat_mode_for_heat_circuit}:${heat_mode_id}`;
    });
}
